<template>
	<main>
		<div class="section s2">
			<a-section class="section-wrap">
				<div class="title-box"></div>
				<div class="content-box">
					<div class="content">
						<p>以科技创新为核心驱动力的新质生产力正在深刻改变产业发展路径，人工智能作为推动产业变革的“终极引擎”，全方位重塑各行业的发展格局。存力已成为贯通数据、算法与算力的核心纽带，通过数据的动态赋能，激活产业智能的无限生命力。</p>
						<p>联想凌拓始终致力于成为新质生产力建设的参与者、推动者与创新引领者。通过构建智能数据基础设施为人工智能系统提供坚实、智能的数据存储和管理平台，一站式AI解决方案助力企业高效灵活地应对不断增长的密集型计算任务和多元化的应用需求，加速AI技术在各行业的规模化落地，实现数智化跃迁。</p>
						<p>值此之际，我们诚挚地邀请您出席由联想凌拓主办的“智能存储及数据管理行业盛会”—联想凌拓2025技术大会（INSIGHT CHINA 2025）。届时，我们将邀业界专家、媒体朋友、行业客户及生态合作伙伴，分享智算时代中数据驱动AI应用的创新技术，探讨AI浪潮下的数据基建核心逻辑，展望人工智能推动行业升级的变革方向。</p>
					</div>
					<div class="info">
						<div class="item">
							<div class="tit">会议时间:</div>
							<div class="text">2025年11月13日</div>
						</div>
						<div class="item">
							<div class="tit">会议地点:</div>
							<div class="text">北京望京凯悦酒店 二层 大宴会厅（北京市朝阳区广顺南大街8号院2号楼）</div>
						</div>
					</div>
				</div>
			</a-section>
		</div>
	</main>
</template>
<script>
export default {}
</script>

<style lang="scss" scoped>
.s2 {color: #111111;position: relative;padding-top: 80px;
	.section-wrap {text-align: center;position: relative;z-index: 10;
		.title-box {display: inline-block; width: 537px;height: 134px; background: url("~@/assets/image/2024/t1.png") no-repeat top center;background-size: contain; }
		.content-box {margin-top: 30px;
			.content {padding: 50px 50px 0;font-size: 18px;line-height: 40px;text-align: left;
				p {text-indent: 40px;}
			}
			.info {text-align: left;padding: 0 50px;font-size: 18px;line-height: 40px;
				.item {display: flex;
					.tit {margin-right: 15px;}
					.text {flex: 1;}
				}
				.item:nth-last-child(1) {margin-bottom: 0;}
			}
		}
	}
}
.s2::after {content: "";display: block;position: absolute;top: 150px;right: 0;width: 540px;height: 180px;background: url("~@/assets/image/2024/i1.png") no-repeat right top;background-size: contain;}
@media screen and (max-width: 1230px) {
	.s2 {padding-top: middle(40px);
		.section-wrap {
			.title-box {width: middle(537px);height: middle(134px); padding: middle(60px) 0 middle(5px);}
			.content-box {margin-top: middle(30px);
				.content {padding: middle(50px) middle(50px) 0;font-size: middle(18px);line-height: middle(40px);
					p {text-indent: middle(40px);}
				}
				.info {padding: 0 middle(50px);font-size: middle(18px);line-height: middle(40px);
					.item {
						.tit {margin-right: middle(15px);}
					}
				}
			}
		}
	}
	.s2::after {top: middle(150px);width: middle(540px);height: middle(180px);}
}
@media screen and (max-width: 992px) {
	.s2 {padding-top: 40px;
		.section-wrap {
			.title-box {width: 100%;height: 67px;}
			.content-box {margin-top: 12px;
				.content {padding: 0;font-size: 14px;line-height: 1.6;
					p {text-indent: 30px;}
				}
				.info {padding: 0;font-size: 14px;line-height: 1.6;
					.item {
						.tit {margin-right: 7px;}
					}
				}
			}
		}
	}
	.s2::after {top: 150px;width: 270px;height: 90px;}
}
</style>
